/* eslint-disable */
// prettier-ignore
import * as Types from '../../../../../graphql/__generated__';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OfferingDetails_PublishedOffering_FilingsFragment = {
  readonly __typename?: 'FilingFull';
  readonly id: string;
  readonly primarySharesOverAllotmentAuthorized?: number | null;
  readonly secondarySharesOverAllotmentAuthorized?: number | null;
  readonly totalSharesOverAllotmentAuthorized?: number | null;
  readonly notionalOverAllotmentAuthorized?: number | null;
  readonly offerPrice?: number | null;
  readonly primarySharesBaseOffering?: number | null;
  readonly secondarySharesBaseOffering?: number | null;
  readonly totalSharesBaseOffering?: number | null;
  readonly ipoRangeHigh?: number | null;
  readonly ipoRangeLow?: number | null;
  readonly filingType: Types.FilingType;
  readonly useOfProceeds?: ReadonlyArray<Types.UseOfProceeds> | null;
  readonly sizeInCurrency?: number | null;
  readonly parValue?: number | null;
  readonly couponTalkHigh?: number | null;
  readonly couponTalkLow?: number | null;
  readonly premium?: number | null;
  readonly premiumTalkHigh?: number | null;
  readonly premiumTalkLow?: number | null;
  readonly conversionPrice?: number | null;
  readonly initialConversionRatio?: number | null;
  readonly coupon?: number | null;
};

export type OfferingDetails_PublishedOffering_FollowOnPricingFragment = {
  readonly __typename?: 'FollowOnPricingFull';
  readonly lastTradeBeforeLaunch?: number | null;
  readonly lastTradeBeforeOffer?: number | null;
  readonly reOfferHigh?: number | null;
  readonly reOfferLow?: number | null;
};

export type OfferingDetails_PublishedOffering_FlagWithNotesPartsFragment = {
  readonly __typename?: 'FlagWithNotesFull';
  readonly enabled: boolean;
  readonly notes: string;
};

export type OfferingDetails_PublishedOffering_TermsFragment = {
  readonly __typename?: 'TermsFull';
  readonly useOfProceeds?: ReadonlyArray<Types.UseOfProceeds> | null;
  readonly maturityDate?: string | null;
  readonly callable?: boolean | null;
  readonly callDates?: ReadonlyArray<string> | null;
  readonly provisionCall?: {
    readonly __typename?: 'FlagWithNotesFull';
    readonly enabled: boolean;
    readonly notes: string;
  } | null;
  readonly puttable?: {
    readonly __typename?: 'FlagWithNotesFull';
    readonly enabled: boolean;
    readonly notes: string;
  } | null;
  readonly perpetual?: {
    readonly __typename?: 'FlagWithNotesFull';
    readonly enabled: boolean;
    readonly notes: string;
  } | null;
  readonly contingentPayment?: {
    readonly __typename?: 'FlagWithNotesFull';
    readonly enabled: boolean;
    readonly notes: string;
  } | null;
  readonly contingentConversion?: {
    readonly __typename?: 'FlagWithNotesFull';
    readonly enabled: boolean;
    readonly notes: string;
  } | null;
  readonly dividendProtection?: {
    readonly __typename?: 'FlagWithNotesFull';
    readonly enabled: boolean;
    readonly notes: string;
  } | null;
  readonly hedging?: {
    readonly __typename?: 'FlagWithNotesFull';
    readonly enabled: boolean;
    readonly notes: string;
  } | null;
  readonly changeOfControl?: {
    readonly __typename?: 'FlagWithNotesFull';
    readonly enabled: boolean;
    readonly notes: string;
  } | null;
  readonly filings: ReadonlyArray<{
    readonly __typename?: 'FilingFull';
    readonly id: string;
    readonly primarySharesOverAllotmentAuthorized?: number | null;
    readonly secondarySharesOverAllotmentAuthorized?: number | null;
    readonly totalSharesOverAllotmentAuthorized?: number | null;
    readonly notionalOverAllotmentAuthorized?: number | null;
    readonly offerPrice?: number | null;
    readonly primarySharesBaseOffering?: number | null;
    readonly secondarySharesBaseOffering?: number | null;
    readonly totalSharesBaseOffering?: number | null;
    readonly ipoRangeHigh?: number | null;
    readonly ipoRangeLow?: number | null;
    readonly filingType: Types.FilingType;
    readonly useOfProceeds?: ReadonlyArray<Types.UseOfProceeds> | null;
    readonly sizeInCurrency?: number | null;
    readonly parValue?: number | null;
    readonly couponTalkHigh?: number | null;
    readonly couponTalkLow?: number | null;
    readonly premium?: number | null;
    readonly premiumTalkHigh?: number | null;
    readonly premiumTalkLow?: number | null;
    readonly conversionPrice?: number | null;
    readonly initialConversionRatio?: number | null;
    readonly coupon?: number | null;
  }>;
  readonly followOnPricing?: {
    readonly __typename?: 'FollowOnPricingFull';
    readonly lastTradeBeforeLaunch?: number | null;
    readonly lastTradeBeforeOffer?: number | null;
    readonly reOfferHigh?: number | null;
    readonly reOfferLow?: number | null;
  } | null;
};

export type OfferingDetails_PublishedOffering_ProspectusDocumentFragment = {
  readonly __typename?: 'ProspectusDocumentFull';
  readonly id: string;
  readonly publicUrl?: string | null;
  readonly documentName: string;
};

export type OfferingDetails_PublishedOffering_DisclaimersFragment = {
  readonly __typename?: 'DisclaimersFull';
  readonly registrationLinks: ReadonlyArray<string>;
  readonly restrictions?: string | null;
  readonly footnotes?: string | null;
  readonly rule134Legend?: string | null;
};

export type OfferingDetails_PublishedOffering_InstrumentPartsFragment = {
  readonly __typename?: 'InstrumentFull';
  readonly id: string;
  readonly sellingRestrictions?: Types.SellingRestrictions | null;
  readonly rank?: Types.Rank | null;
  readonly countryCode?: string | null;
  readonly isDepositaryReceipt?: boolean | null;
};

export type OfferingDetails_PublishedOffering_SyndicateFragment = {
  readonly __typename?: 'SyndicateFull';
  readonly managerResponsibilities: {
    readonly __typename?: 'ManagerResponsibilitiesFull';
    readonly leftLead?: string | null;
    readonly settlementAgent?: string | null;
    readonly stabilizationAgent?: string | null;
    readonly logisticsAgent?: string | null;
  };
  readonly managers: ReadonlyArray<{
    readonly __typename?: 'ManagerFull';
    readonly id: string;
    readonly cmgEntityKey: string;
    readonly firmName: string;
    readonly role: Types.ManagerRole;
  }>;
};

export type OfferingDetails_PublishedOfferingFragment = {
  readonly __typename?: 'OfferingFull';
  readonly id: string;
  readonly status: Types.OfferingStatus;
  readonly stage: Types.OfferingStage;
  readonly type: Types.OfferingType;
  readonly hasForwardAgreement?: boolean | null;
  readonly pricingCurrencyCode: string;
  readonly pricingInstrumentId?: string | null;
  readonly disclaimers?: {
    readonly __typename?: 'DisclaimersFull';
    readonly registrationLinks: ReadonlyArray<string>;
    readonly restrictions?: string | null;
    readonly footnotes?: string | null;
    readonly rule134Legend?: string | null;
  } | null;
  readonly prospectusDocuments?: ReadonlyArray<{
    readonly __typename?: 'ProspectusDocumentFull';
    readonly id: string;
    readonly publicUrl?: string | null;
    readonly documentName: string;
  }> | null;
  readonly issuer: {
    readonly __typename?: 'IssuerFull';
    readonly businessDescription?: string | null;
  };
  readonly instruments: ReadonlyArray<{
    readonly __typename?: 'InstrumentFull';
    readonly id: string;
    readonly sellingRestrictions?: Types.SellingRestrictions | null;
    readonly rank?: Types.Rank | null;
    readonly countryCode?: string | null;
    readonly isDepositaryReceipt?: boolean | null;
  }>;
  readonly security: {
    readonly __typename?: 'SecurityFull';
    readonly typeDisplayName?: string | null;
  };
  readonly timing: {
    readonly __typename?: 'TimingFull';
    readonly pricingDate?: string | null;
    readonly firstTradeDate?: string | null;
    readonly settlementDate?: string | null;
    readonly bookOpenDate?: string | null;
    readonly bookOpenTime?: string | null;
    readonly bookCloseDate?: string | null;
    readonly bookCloseTime?: string | null;
    readonly timeZone?: string | null;
  };
  readonly syndicate?: {
    readonly __typename?: 'SyndicateFull';
    readonly managerResponsibilities: {
      readonly __typename?: 'ManagerResponsibilitiesFull';
      readonly leftLead?: string | null;
      readonly settlementAgent?: string | null;
      readonly stabilizationAgent?: string | null;
      readonly logisticsAgent?: string | null;
    };
    readonly managers: ReadonlyArray<{
      readonly __typename?: 'ManagerFull';
      readonly id: string;
      readonly cmgEntityKey: string;
      readonly firmName: string;
      readonly role: Types.ManagerRole;
    }>;
  } | null;
  readonly roadshowSchedules?: ReadonlyArray<{
    readonly __typename?: 'RoadshowsFull';
    readonly id: string;
    readonly date: string;
    readonly details: string;
  }> | null;
  readonly marketing?: {
    readonly __typename?: 'MarketingFull';
    readonly managementTeam?: string | null;
    readonly callDetails?: string | null;
  } | null;
  readonly terms: {
    readonly __typename?: 'TermsFull';
    readonly useOfProceeds?: ReadonlyArray<Types.UseOfProceeds> | null;
    readonly maturityDate?: string | null;
    readonly callable?: boolean | null;
    readonly callDates?: ReadonlyArray<string> | null;
    readonly provisionCall?: {
      readonly __typename?: 'FlagWithNotesFull';
      readonly enabled: boolean;
      readonly notes: string;
    } | null;
    readonly puttable?: {
      readonly __typename?: 'FlagWithNotesFull';
      readonly enabled: boolean;
      readonly notes: string;
    } | null;
    readonly perpetual?: {
      readonly __typename?: 'FlagWithNotesFull';
      readonly enabled: boolean;
      readonly notes: string;
    } | null;
    readonly contingentPayment?: {
      readonly __typename?: 'FlagWithNotesFull';
      readonly enabled: boolean;
      readonly notes: string;
    } | null;
    readonly contingentConversion?: {
      readonly __typename?: 'FlagWithNotesFull';
      readonly enabled: boolean;
      readonly notes: string;
    } | null;
    readonly dividendProtection?: {
      readonly __typename?: 'FlagWithNotesFull';
      readonly enabled: boolean;
      readonly notes: string;
    } | null;
    readonly hedging?: {
      readonly __typename?: 'FlagWithNotesFull';
      readonly enabled: boolean;
      readonly notes: string;
    } | null;
    readonly changeOfControl?: {
      readonly __typename?: 'FlagWithNotesFull';
      readonly enabled: boolean;
      readonly notes: string;
    } | null;
    readonly filings: ReadonlyArray<{
      readonly __typename?: 'FilingFull';
      readonly id: string;
      readonly primarySharesOverAllotmentAuthorized?: number | null;
      readonly secondarySharesOverAllotmentAuthorized?: number | null;
      readonly totalSharesOverAllotmentAuthorized?: number | null;
      readonly notionalOverAllotmentAuthorized?: number | null;
      readonly offerPrice?: number | null;
      readonly primarySharesBaseOffering?: number | null;
      readonly secondarySharesBaseOffering?: number | null;
      readonly totalSharesBaseOffering?: number | null;
      readonly ipoRangeHigh?: number | null;
      readonly ipoRangeLow?: number | null;
      readonly filingType: Types.FilingType;
      readonly useOfProceeds?: ReadonlyArray<Types.UseOfProceeds> | null;
      readonly sizeInCurrency?: number | null;
      readonly parValue?: number | null;
      readonly couponTalkHigh?: number | null;
      readonly couponTalkLow?: number | null;
      readonly premium?: number | null;
      readonly premiumTalkHigh?: number | null;
      readonly premiumTalkLow?: number | null;
      readonly conversionPrice?: number | null;
      readonly initialConversionRatio?: number | null;
      readonly coupon?: number | null;
    }>;
    readonly followOnPricing?: {
      readonly __typename?: 'FollowOnPricingFull';
      readonly lastTradeBeforeLaunch?: number | null;
      readonly lastTradeBeforeOffer?: number | null;
      readonly reOfferHigh?: number | null;
      readonly reOfferLow?: number | null;
    } | null;
  };
};

export type OfferingDetails_PublishedOfferingQueryVariables = Types.Exact<{
  offeringId: Types.Scalars['UUID']['input'];
}>;

export type OfferingDetails_PublishedOfferingQuery = {
  readonly __typename?: 'Query';
  readonly publishedOfferings?: {
    readonly __typename?: 'PublishedOfferingsCollectionSegment';
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'OfferingFull';
      readonly id: string;
      readonly status: Types.OfferingStatus;
      readonly stage: Types.OfferingStage;
      readonly type: Types.OfferingType;
      readonly hasForwardAgreement?: boolean | null;
      readonly pricingCurrencyCode: string;
      readonly pricingInstrumentId?: string | null;
      readonly disclaimers?: {
        readonly __typename?: 'DisclaimersFull';
        readonly registrationLinks: ReadonlyArray<string>;
        readonly restrictions?: string | null;
        readonly footnotes?: string | null;
        readonly rule134Legend?: string | null;
      } | null;
      readonly prospectusDocuments?: ReadonlyArray<{
        readonly __typename?: 'ProspectusDocumentFull';
        readonly id: string;
        readonly publicUrl?: string | null;
        readonly documentName: string;
      }> | null;
      readonly issuer: {
        readonly __typename?: 'IssuerFull';
        readonly businessDescription?: string | null;
      };
      readonly instruments: ReadonlyArray<{
        readonly __typename?: 'InstrumentFull';
        readonly id: string;
        readonly sellingRestrictions?: Types.SellingRestrictions | null;
        readonly rank?: Types.Rank | null;
        readonly countryCode?: string | null;
        readonly isDepositaryReceipt?: boolean | null;
      }>;
      readonly security: {
        readonly __typename?: 'SecurityFull';
        readonly typeDisplayName?: string | null;
      };
      readonly timing: {
        readonly __typename?: 'TimingFull';
        readonly pricingDate?: string | null;
        readonly firstTradeDate?: string | null;
        readonly settlementDate?: string | null;
        readonly bookOpenDate?: string | null;
        readonly bookOpenTime?: string | null;
        readonly bookCloseDate?: string | null;
        readonly bookCloseTime?: string | null;
        readonly timeZone?: string | null;
      };
      readonly syndicate?: {
        readonly __typename?: 'SyndicateFull';
        readonly managerResponsibilities: {
          readonly __typename?: 'ManagerResponsibilitiesFull';
          readonly leftLead?: string | null;
          readonly settlementAgent?: string | null;
          readonly stabilizationAgent?: string | null;
          readonly logisticsAgent?: string | null;
        };
        readonly managers: ReadonlyArray<{
          readonly __typename?: 'ManagerFull';
          readonly id: string;
          readonly cmgEntityKey: string;
          readonly firmName: string;
          readonly role: Types.ManagerRole;
        }>;
      } | null;
      readonly roadshowSchedules?: ReadonlyArray<{
        readonly __typename?: 'RoadshowsFull';
        readonly id: string;
        readonly date: string;
        readonly details: string;
      }> | null;
      readonly marketing?: {
        readonly __typename?: 'MarketingFull';
        readonly managementTeam?: string | null;
        readonly callDetails?: string | null;
      } | null;
      readonly terms: {
        readonly __typename?: 'TermsFull';
        readonly useOfProceeds?: ReadonlyArray<Types.UseOfProceeds> | null;
        readonly maturityDate?: string | null;
        readonly callable?: boolean | null;
        readonly callDates?: ReadonlyArray<string> | null;
        readonly provisionCall?: {
          readonly __typename?: 'FlagWithNotesFull';
          readonly enabled: boolean;
          readonly notes: string;
        } | null;
        readonly puttable?: {
          readonly __typename?: 'FlagWithNotesFull';
          readonly enabled: boolean;
          readonly notes: string;
        } | null;
        readonly perpetual?: {
          readonly __typename?: 'FlagWithNotesFull';
          readonly enabled: boolean;
          readonly notes: string;
        } | null;
        readonly contingentPayment?: {
          readonly __typename?: 'FlagWithNotesFull';
          readonly enabled: boolean;
          readonly notes: string;
        } | null;
        readonly contingentConversion?: {
          readonly __typename?: 'FlagWithNotesFull';
          readonly enabled: boolean;
          readonly notes: string;
        } | null;
        readonly dividendProtection?: {
          readonly __typename?: 'FlagWithNotesFull';
          readonly enabled: boolean;
          readonly notes: string;
        } | null;
        readonly hedging?: {
          readonly __typename?: 'FlagWithNotesFull';
          readonly enabled: boolean;
          readonly notes: string;
        } | null;
        readonly changeOfControl?: {
          readonly __typename?: 'FlagWithNotesFull';
          readonly enabled: boolean;
          readonly notes: string;
        } | null;
        readonly filings: ReadonlyArray<{
          readonly __typename?: 'FilingFull';
          readonly id: string;
          readonly primarySharesOverAllotmentAuthorized?: number | null;
          readonly secondarySharesOverAllotmentAuthorized?: number | null;
          readonly totalSharesOverAllotmentAuthorized?: number | null;
          readonly notionalOverAllotmentAuthorized?: number | null;
          readonly offerPrice?: number | null;
          readonly primarySharesBaseOffering?: number | null;
          readonly secondarySharesBaseOffering?: number | null;
          readonly totalSharesBaseOffering?: number | null;
          readonly ipoRangeHigh?: number | null;
          readonly ipoRangeLow?: number | null;
          readonly filingType: Types.FilingType;
          readonly useOfProceeds?: ReadonlyArray<Types.UseOfProceeds> | null;
          readonly sizeInCurrency?: number | null;
          readonly parValue?: number | null;
          readonly couponTalkHigh?: number | null;
          readonly couponTalkLow?: number | null;
          readonly premium?: number | null;
          readonly premiumTalkHigh?: number | null;
          readonly premiumTalkLow?: number | null;
          readonly conversionPrice?: number | null;
          readonly initialConversionRatio?: number | null;
          readonly coupon?: number | null;
        }>;
        readonly followOnPricing?: {
          readonly __typename?: 'FollowOnPricingFull';
          readonly lastTradeBeforeLaunch?: number | null;
          readonly lastTradeBeforeOffer?: number | null;
          readonly reOfferHigh?: number | null;
          readonly reOfferLow?: number | null;
        } | null;
      };
    }> | null;
  } | null;
};

export const OfferingDetails_PublishedOffering_DisclaimersFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OfferingDetails_PublishedOffering_Disclaimers' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DisclaimersFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'registrationLinks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'restrictions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'footnotes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rule134Legend' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const OfferingDetails_PublishedOffering_ProspectusDocumentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OfferingDetails_PublishedOffering_ProspectusDocument' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProspectusDocumentFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const OfferingDetails_PublishedOffering_InstrumentPartsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OfferingDetails_PublishedOffering_InstrumentParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InstrumentFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sellingRestrictions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDepositaryReceipt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const OfferingDetails_PublishedOffering_SyndicateFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OfferingDetails_PublishedOffering_Syndicate' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SyndicateFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'managerResponsibilities' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'leftLead' } },
                { kind: 'Field', name: { kind: 'Name', value: 'settlementAgent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stabilizationAgent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'logisticsAgent' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'managers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cmgEntityKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firmName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const OfferingDetails_PublishedOffering_FlagWithNotesPartsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OfferingDetails_PublishedOffering_FlagWithNotesParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FlagWithNotesFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const OfferingDetails_PublishedOffering_FilingsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OfferingDetails_PublishedOffering_Filings' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FilingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primarySharesOverAllotmentAuthorized' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'secondarySharesOverAllotmentAuthorized' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'totalSharesOverAllotmentAuthorized' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notionalOverAllotmentAuthorized' } },
          { kind: 'Field', name: { kind: 'Name', value: 'offerPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primarySharesBaseOffering' } },
          { kind: 'Field', name: { kind: 'Name', value: 'secondarySharesBaseOffering' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalSharesBaseOffering' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ipoRangeHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ipoRangeLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filingType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'useOfProceeds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizeInCurrency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'couponTalkHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'couponTalkLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premium' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premiumTalkHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premiumTalkLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversionPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'initialConversionRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coupon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premium' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const OfferingDetails_PublishedOffering_FollowOnPricingFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OfferingDetails_PublishedOffering_FollowOnPricing' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FollowOnPricingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'lastTradeBeforeLaunch' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastTradeBeforeOffer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reOfferHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reOfferLow' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const OfferingDetails_PublishedOffering_TermsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OfferingDetails_PublishedOffering_Terms' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TermsFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'useOfProceeds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maturityDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDates' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'provisionCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'OfferingDetails_PublishedOffering_FlagWithNotesParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'puttable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'OfferingDetails_PublishedOffering_FlagWithNotesParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'perpetual' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'OfferingDetails_PublishedOffering_FlagWithNotesParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contingentPayment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'OfferingDetails_PublishedOffering_FlagWithNotesParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contingentConversion' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'OfferingDetails_PublishedOffering_FlagWithNotesParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dividendProtection' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'OfferingDetails_PublishedOffering_FlagWithNotesParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hedging' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'OfferingDetails_PublishedOffering_FlagWithNotesParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'changeOfControl' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'OfferingDetails_PublishedOffering_FlagWithNotesParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'filings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OfferingDetails_PublishedOffering_Filings' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'followOnPricing' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'OfferingDetails_PublishedOffering_FollowOnPricing',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OfferingDetails_PublishedOffering_Filings' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FilingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primarySharesOverAllotmentAuthorized' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'secondarySharesOverAllotmentAuthorized' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'totalSharesOverAllotmentAuthorized' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notionalOverAllotmentAuthorized' } },
          { kind: 'Field', name: { kind: 'Name', value: 'offerPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primarySharesBaseOffering' } },
          { kind: 'Field', name: { kind: 'Name', value: 'secondarySharesBaseOffering' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalSharesBaseOffering' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ipoRangeHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ipoRangeLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filingType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'useOfProceeds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizeInCurrency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'couponTalkHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'couponTalkLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premium' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premiumTalkHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premiumTalkLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversionPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'initialConversionRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coupon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premium' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OfferingDetails_PublishedOffering_FollowOnPricing' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FollowOnPricingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'lastTradeBeforeLaunch' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastTradeBeforeOffer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reOfferHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reOfferLow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OfferingDetails_PublishedOffering_FlagWithNotesParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FlagWithNotesFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const OfferingDetails_PublishedOfferingFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OfferingDetails_PublishedOffering' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'OfferingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasForwardAgreement' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pricingCurrencyCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pricingInstrumentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disclaimers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OfferingDetails_PublishedOffering_Disclaimers' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prospectusDocuments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'OfferingDetails_PublishedOffering_ProspectusDocument',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'businessDescription' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instruments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'OfferingDetails_PublishedOffering_InstrumentParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'security' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'typeDisplayName' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'timing' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'pricingDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstTradeDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'settlementDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bookOpenDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bookOpenTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bookCloseDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bookCloseTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeZone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'syndicate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OfferingDetails_PublishedOffering_Syndicate' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'roadshowSchedules' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'details' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketing' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'managementTeam' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callDetails' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'terms' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OfferingDetails_PublishedOffering_Terms' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OfferingDetails_PublishedOffering_Filings' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FilingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primarySharesOverAllotmentAuthorized' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'secondarySharesOverAllotmentAuthorized' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'totalSharesOverAllotmentAuthorized' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notionalOverAllotmentAuthorized' } },
          { kind: 'Field', name: { kind: 'Name', value: 'offerPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primarySharesBaseOffering' } },
          { kind: 'Field', name: { kind: 'Name', value: 'secondarySharesBaseOffering' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalSharesBaseOffering' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ipoRangeHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ipoRangeLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filingType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'useOfProceeds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizeInCurrency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'couponTalkHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'couponTalkLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premium' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premiumTalkHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premiumTalkLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversionPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'initialConversionRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coupon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premium' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OfferingDetails_PublishedOffering_FollowOnPricing' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FollowOnPricingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'lastTradeBeforeLaunch' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastTradeBeforeOffer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reOfferHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reOfferLow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OfferingDetails_PublishedOffering_FlagWithNotesParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FlagWithNotesFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OfferingDetails_PublishedOffering_Terms' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TermsFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'useOfProceeds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maturityDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDates' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'provisionCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'OfferingDetails_PublishedOffering_FlagWithNotesParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'puttable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'OfferingDetails_PublishedOffering_FlagWithNotesParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'perpetual' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'OfferingDetails_PublishedOffering_FlagWithNotesParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contingentPayment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'OfferingDetails_PublishedOffering_FlagWithNotesParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contingentConversion' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'OfferingDetails_PublishedOffering_FlagWithNotesParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dividendProtection' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'OfferingDetails_PublishedOffering_FlagWithNotesParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hedging' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'OfferingDetails_PublishedOffering_FlagWithNotesParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'changeOfControl' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'OfferingDetails_PublishedOffering_FlagWithNotesParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'filings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OfferingDetails_PublishedOffering_Filings' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'followOnPricing' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'OfferingDetails_PublishedOffering_FollowOnPricing',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OfferingDetails_PublishedOffering_ProspectusDocument' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProspectusDocumentFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OfferingDetails_PublishedOffering_Disclaimers' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DisclaimersFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'registrationLinks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'restrictions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'footnotes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rule134Legend' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OfferingDetails_PublishedOffering_InstrumentParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InstrumentFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sellingRestrictions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDepositaryReceipt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OfferingDetails_PublishedOffering_Syndicate' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SyndicateFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'managerResponsibilities' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'leftLead' } },
                { kind: 'Field', name: { kind: 'Name', value: 'settlementAgent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stabilizationAgent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'logisticsAgent' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'managers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cmgEntityKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firmName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const OfferingDetails_PublishedOfferingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'OfferingDetails_PublishedOffering' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offeringId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'publishedOfferings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'offeringId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'OfferingDetails_PublishedOffering' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OfferingDetails_PublishedOffering_Filings' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FilingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primarySharesOverAllotmentAuthorized' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'secondarySharesOverAllotmentAuthorized' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'totalSharesOverAllotmentAuthorized' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notionalOverAllotmentAuthorized' } },
          { kind: 'Field', name: { kind: 'Name', value: 'offerPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primarySharesBaseOffering' } },
          { kind: 'Field', name: { kind: 'Name', value: 'secondarySharesBaseOffering' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalSharesBaseOffering' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ipoRangeHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ipoRangeLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filingType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'useOfProceeds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizeInCurrency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'couponTalkHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'couponTalkLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premium' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premiumTalkHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premiumTalkLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conversionPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'initialConversionRatio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coupon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premium' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OfferingDetails_PublishedOffering_FollowOnPricing' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FollowOnPricingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'lastTradeBeforeLaunch' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastTradeBeforeOffer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reOfferHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reOfferLow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OfferingDetails_PublishedOffering_FlagWithNotesParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FlagWithNotesFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'enabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OfferingDetails_PublishedOffering_Terms' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TermsFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'useOfProceeds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maturityDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callDates' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'provisionCall' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'OfferingDetails_PublishedOffering_FlagWithNotesParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'puttable' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'OfferingDetails_PublishedOffering_FlagWithNotesParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'perpetual' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'OfferingDetails_PublishedOffering_FlagWithNotesParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contingentPayment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'OfferingDetails_PublishedOffering_FlagWithNotesParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contingentConversion' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'OfferingDetails_PublishedOffering_FlagWithNotesParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dividendProtection' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'OfferingDetails_PublishedOffering_FlagWithNotesParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hedging' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'OfferingDetails_PublishedOffering_FlagWithNotesParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'changeOfControl' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'OfferingDetails_PublishedOffering_FlagWithNotesParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'filings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OfferingDetails_PublishedOffering_Filings' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'followOnPricing' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'OfferingDetails_PublishedOffering_FollowOnPricing',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OfferingDetails_PublishedOffering_ProspectusDocument' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProspectusDocumentFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OfferingDetails_PublishedOffering_Disclaimers' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DisclaimersFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'registrationLinks' } },
          { kind: 'Field', name: { kind: 'Name', value: 'restrictions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'footnotes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rule134Legend' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OfferingDetails_PublishedOffering_InstrumentParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InstrumentFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sellingRestrictions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDepositaryReceipt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OfferingDetails_PublishedOffering_Syndicate' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SyndicateFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'managerResponsibilities' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'leftLead' } },
                { kind: 'Field', name: { kind: 'Name', value: 'settlementAgent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stabilizationAgent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'logisticsAgent' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'managers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cmgEntityKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firmName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OfferingDetails_PublishedOffering' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'OfferingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasForwardAgreement' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pricingCurrencyCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pricingInstrumentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disclaimers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OfferingDetails_PublishedOffering_Disclaimers' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prospectusDocuments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'OfferingDetails_PublishedOffering_ProspectusDocument',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'businessDescription' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instruments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'OfferingDetails_PublishedOffering_InstrumentParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'security' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'typeDisplayName' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'timing' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'pricingDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstTradeDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'settlementDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bookOpenDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bookOpenTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bookCloseDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bookCloseTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeZone' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'syndicate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OfferingDetails_PublishedOffering_Syndicate' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'roadshowSchedules' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'details' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketing' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'managementTeam' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callDetails' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'terms' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OfferingDetails_PublishedOffering_Terms' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useOfferingDetails_PublishedOfferingQuery__
 *
 * To run a query within a React component, call `useOfferingDetails_PublishedOfferingQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferingDetails_PublishedOfferingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfferingDetails_PublishedOfferingQuery({
 *   variables: {
 *      offeringId: // value for 'offeringId'
 *   },
 * });
 */
export function useOfferingDetails_PublishedOfferingQuery(
  baseOptions: Apollo.QueryHookOptions<
    OfferingDetails_PublishedOfferingQuery,
    OfferingDetails_PublishedOfferingQueryVariables
  > &
    (
      | { variables: OfferingDetails_PublishedOfferingQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    OfferingDetails_PublishedOfferingQuery,
    OfferingDetails_PublishedOfferingQueryVariables
  >(OfferingDetails_PublishedOfferingDocument, options);
}
export function useOfferingDetails_PublishedOfferingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OfferingDetails_PublishedOfferingQuery,
    OfferingDetails_PublishedOfferingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OfferingDetails_PublishedOfferingQuery,
    OfferingDetails_PublishedOfferingQueryVariables
  >(OfferingDetails_PublishedOfferingDocument, options);
}
// @ts-ignore
export function useOfferingDetails_PublishedOfferingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OfferingDetails_PublishedOfferingQuery,
    OfferingDetails_PublishedOfferingQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  OfferingDetails_PublishedOfferingQuery,
  OfferingDetails_PublishedOfferingQueryVariables
>;
export function useOfferingDetails_PublishedOfferingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OfferingDetails_PublishedOfferingQuery,
        OfferingDetails_PublishedOfferingQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  OfferingDetails_PublishedOfferingQuery | undefined,
  OfferingDetails_PublishedOfferingQueryVariables
>;
export function useOfferingDetails_PublishedOfferingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OfferingDetails_PublishedOfferingQuery,
        OfferingDetails_PublishedOfferingQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    OfferingDetails_PublishedOfferingQuery,
    OfferingDetails_PublishedOfferingQueryVariables
  >(OfferingDetails_PublishedOfferingDocument, options);
}
export type OfferingDetails_PublishedOfferingQueryHookResult = ReturnType<
  typeof useOfferingDetails_PublishedOfferingQuery
>;
export type OfferingDetails_PublishedOfferingLazyQueryHookResult = ReturnType<
  typeof useOfferingDetails_PublishedOfferingLazyQuery
>;
export type OfferingDetails_PublishedOfferingSuspenseQueryHookResult = ReturnType<
  typeof useOfferingDetails_PublishedOfferingSuspenseQuery
>;
export type OfferingDetails_PublishedOfferingQueryResult = Apollo.QueryResult<
  OfferingDetails_PublishedOfferingQuery,
  OfferingDetails_PublishedOfferingQueryVariables
>;

import { makeMockResponse } from '../../../../../graphql/mock-response';

export const makeOfferingDetails_PublishedOfferingMockResponse = makeMockResponse<
  OfferingDetails_PublishedOfferingQueryVariables,
  OfferingDetails_PublishedOfferingQuery
>(OfferingDetails_PublishedOfferingDocument);
